import React from "react";
import { Card } from '@/components/ui/card';
import { Calculator, TrendingUp, Users, Percent } from 'lucide-react';

interface ARRHighlightCardProps {
  year1ARR: string;
  pricingAssumption: string;
  userAcquisition: string;
  grossMargin: string;
}

export function ARRHighlightCard({
  year1ARR,
  pricingAssumption,
  userAcquisition,
  grossMargin
}: ARRHighlightCardProps) {
  return (
    <Card className="p-5 mb-6 rounded-2xl shadow-md bg-gradient-to-br from-primary/5 via-card to-green-500/5 border-2 border-primary/20">
      <div className="flex items-center gap-2 mb-4">
        <Calculator className="w-5 h-5 text-primary" />
        <h3 className="text-base font-semibold text-primary">Estimated ARR & Unit Economics</h3>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center p-3 rounded-xl bg-background/50">
          <TrendingUp className="w-5 h-5 text-green-600 mx-auto mb-2" />
          <p className="text-xs text-muted-foreground mb-1">Year 1 ARR (Base)</p>
          <p className="text-lg font-bold text-foreground">{year1ARR}</p>
        </div>
        
        <div className="text-center p-3 rounded-xl bg-background/50">
          <Calculator className="w-5 h-5 text-blue-600 mx-auto mb-2" />
          <p className="text-xs text-muted-foreground mb-1">Pricing</p>
          <p className="text-sm font-medium text-foreground line-clamp-2">{pricingAssumption}</p>
        </div>
        
        <div className="text-center p-3 rounded-xl bg-background/50">
          <Users className="w-5 h-5 text-purple-600 mx-auto mb-2" />
          <p className="text-xs text-muted-foreground mb-1">User Acquisition</p>
          <p className="text-sm font-medium text-foreground line-clamp-2">{userAcquisition}</p>
        </div>
        
        <div className="text-center p-3 rounded-xl bg-background/50">
          <Percent className="w-5 h-5 text-orange-600 mx-auto mb-2" />
          <p className="text-xs text-muted-foreground mb-1">Gross Margin</p>
          <p className="text-lg font-bold text-foreground">{grossMargin}</p>
        </div>
      </div>
    </Card>
  );
}
